export const buildChatId = (senderId: string, receiverId: string) =>
  `${senderId}|${receiverId}`

export const getChatSenderId = (chatId: string) => chatId.split("|")[0]
export const getChatReceiverId = (chatId: string) => chatId.split("|")[1]

export const specularChatId = (chatId: string) =>
  buildChatId(getChatReceiverId(chatId), getChatSenderId(chatId))
